const getScreenSize = () => {
  const width = window.innerWidth;
  if (width <= 480) return "xs";
  if (width <= 768) return "sm";
  if (width <= 1024) return "md";
  if (width <= 1366) return "lg";
  if (width <= 1920) return "xl";
  return "xxl";
};

const getResponsiveSpacing = (screenSize) => {
  const spacingMap = {
    xs: { padding: "0.75rem", margin: "0.75rem", gap: "0.5rem" },
    sm: { padding: "1rem", margin: "1rem", gap: "0.75rem" },
    md: { padding: "1.25rem", margin: "1.25rem", gap: "1rem" },
    lg: { padding: "1.5rem", margin: "1.5rem", gap: "1.25rem" },
    xl: { padding: "1.75rem", margin: "1.75rem", gap: "1.5rem" },
    xxl: { padding: "2rem", margin: "2rem", gap: "1.75rem" },
  };
  return spacingMap[screenSize] || spacingMap.md;
};

const getResponsiveFontSizes = (screenSize) => {
  const fontMap = {
    xs: {
      tiny: "0.625rem",
      small: "0.75rem",
      body: "0.875rem",
      large: "1rem",
      xlarge: "1.25rem",
    },
    sm: {
      tiny: "0.6875rem",
      small: "0.8125rem",
      body: "0.9375rem",
      large: "1.125rem",
      xlarge: "1.375rem",
    },
    md: {
      tiny: "0.75rem",
      small: "0.875rem",
      body: "1rem",
      large: "1.25rem",
      xlarge: "1.5rem",
    },
    lg: {
      tiny: "0.8125rem",
      small: "0.9375rem",
      body: "1.0625rem",
      large: "1.375rem",
      xlarge: "1.625rem",
    },
    xl: {
      tiny: "0.875rem",
      small: "1rem",
      body: "1.125rem",
      large: "1.5rem",
      xlarge: "1.75rem",
    },
    xxl: {
      tiny: "0.9375rem",
      small: "1.0625rem",
      body: "1.25rem",
      large: "1.625rem",
      xlarge: "2rem",
    },
  };
  return fontMap[screenSize] || fontMap.md;
};

const getResponsiveContainer = (screenSize) => {
  const containerMap = {
    xs: { maxWidth: "100%", padding: "0.75rem" },
    sm: { maxWidth: "100%", padding: "1rem" },
    md: { maxWidth: "100%", padding: "1.25rem" },
    lg: { maxWidth: "75rem", padding: "1.5rem" },
    xl: { maxWidth: "87.5rem", padding: "1.75rem" },
    xxl: { maxWidth: "100rem", padding: "2rem" },
  };
  return containerMap[screenSize] || containerMap.md;
};

const getResponsiveGrid = (screenSize) => {
  const gridMap = {
    xs: 1, // موبايل صغير: card واحد في الصف
    sm: 2, // موبايل كبير/تابلت: card
    md: 4, // تابلت أفقي: 3 cards
    lg: 4, // لابتوب: 4 cards ✅
    xl: 4, // شاشة كبيرة: 4 cards ✅
    xxl: 4, // شاشة عريضة جداً: 4 cards ✅
  };
  return gridMap[screenSize] || 4;
};

export {
  getScreenSize,
  getResponsiveSpacing,
  getResponsiveFontSizes,
  getResponsiveContainer,
  getResponsiveGrid,
};